import { render, staticRenderFns } from "./Cotizacion.vue?vue&type=template&id=9b58d844"
import script from "./Cotizacion.vue?vue&type=script&lang=js"
export * from "./Cotizacion.vue?vue&type=script&lang=js"
import style0 from "./Cotizacion.vue?vue&type=style&index=0&id=9b58d844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports